/**
 * Menu module
 * Allows toggling the child navigation component
 * @module
 */
import BEM from 'bem.js';


const BLOCK_MENU = 'menu';

const ELEMENT_TOGGLE_NAVIGATION = 'toggle-navigation';

const MODIFIER_MOBILE = 'mobile';

const MODIFIER_OPEN = 'open';

const MODIFIER_NO_SCROLL = 'no-scroll';

const MENU = BEM.getBEMNode(BLOCK_MENU);

const TOGGLE_NAVIGATION = BEM.getBEMNode(BLOCK_MENU, ELEMENT_TOGGLE_NAVIGATION);

const TOGGLE_NAVIGATION_MOBILE = BEM.getBEMNode(BLOCK_MENU, ELEMENT_TOGGLE_NAVIGATION, MODIFIER_MOBILE);


/**
 * NavigationToggle class
 * Allows toggling the child navigation component
 * @class
 */
class NavigationToggle {
    /**
     * Constructor method
     * Gets called when class get instantiated
     */
    constructor() {
        this.setUpToggleNavigation();
    }

    /**
     * Binds click event on TOGGLE_NAVIGATION to this.toggleNavigation()
     */
    setUpToggleNavigation() {
        if(TOGGLE_NAVIGATION) {
            TOGGLE_NAVIGATION.addEventListener('click', this.toggleNavigation.bind(this));
        }
        if(TOGGLE_NAVIGATION_MOBILE) {
            TOGGLE_NAVIGATION_MOBILE.addEventListener('click', this.toggleNavigation.bind(this));
        }
    }

    /**
     * Toggles MODIFIER_OPEN on MENU
     */
    toggleNavigation() {
        BEM.toggleModifier(MENU, MODIFIER_OPEN);
        BEM.toggleModifier(document.body, MODIFIER_NO_SCROLL);
    }
}


new NavigationToggle();  // Initiate this module



// WEBPACK FOOTER //
// ./src/my_artis/js/components/menu.js